/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Col, Grid, Row } from 'react-bootstrap';
import { Form } from 'react-final-form';
import { getOrgTermsContent } from '../../../content/utils.js';
import { retrieveProject, selectProject } from '../../../modules/projects.js';
import useConvertToBase64 from '../../../hooks/useConvertToBase64.js';
import {
  generalStrategyStepValidate,
  navigateToChangeStrategy,
  navigateToStepDetails,
} from './utils/index.js';
import { mapFinalFormErrors } from '../../../lib/utils.js';
import StepGeneralForm from '../../../components/projects/ChangeStrategy/ChnageStrategyForms/StepGeneralForm.jsx';
import {
  deleteChangeStrategyDraft,
  retrieveChangeStrategy,
  selectChangeStrategy,
  selectDraftChangeStrategy,
  updateChangeStrategy,
  updateChangeStrategyDraft,
} from '../../../modules/changeStrategy.js';
import MultistepCombinedHeader from '../../../components/headers/FormHeaders/MultistepCombinedHeader.jsx';
import ChangeStrategyFormHeader from '../../../components/headers/PageHeaders/Project/ChangeStrategy/ChangeStrategyFormHeader.jsx';

const mapErrors = mapFinalFormErrors('Failed to save change strategy');

const mapStateToProps = (state, ownProps) => ({
  editing: !!state.changeStrategy.changeStrategy,
  projectId: ownProps.projectId,
  project: selectProject(ownProps.projectId)(state),
  changeStrategy: selectChangeStrategy(state),
  changeStrategyDraft: selectDraftChangeStrategy(state),
});

const mapDispatchToProps = {
  retrieveProject,
  retrieveChangeStrategy,
  updateChangeStrategy,
  updateChangeStrategyDraft,
  deleteChangeStrategyDraft,
};

function StepGeneralFormContainer({
  slug,
  projectId,
  project,
  retrieveProject,
  retrieveChangeStrategy,
  changeStrategy,
  changeStrategyDraft,
  updateChangeStrategy,
  updateChangeStrategyDraft,
  deleteChangeStrategyDraft,
  editing,
}) {
  const { error, convertToBase64 } = useConvertToBase64();

  const [selectedImage, setSelectedImage] = useState('');
  const [imageSize, setImageSize] = useState('');
  const [loading, setLoading] = useState(false);
  const [isDraftToDelete, setIsDraftToDelete] = useState(true);
  const [showFormModal, setShowFormModal] = useState(false);
  const initialValues = changeStrategyDraft || changeStrategy;

  const goNext = () => {
    navigateToStepDetails(editing, projectId, slug);
  };
  const goStart = () => navigateToChangeStrategy(projectId, slug);

  const clearImageField = () => setSelectedImage('');

  const fields = {
    impact: {
      allow_delete: false,
      allow_editor: false,
      editor: false,
      id: 58,
      key: 'project_impact',
      mandatory: false,
      name: getOrgTermsContent('projectImpact'),
      native_column: 'project_impact',
      priority: 3,
      table_show: true,
    },
  };

  const onCancel = () => {
    deleteChangeStrategyDraft(projectId).then(() => {
      navigateToChangeStrategy(projectId, slug);
    });
  };

  const handleImageSelect = async (e) => {
    const file = e.target.files[0];
    try {
      const result = await convertToBase64(file);
      setSelectedImage(result);
      setImageSize(result.length);
    } catch (err) {
      console.error(error);
    }
  };

  const onSubmit = (values) => {
    const { finish } = values;
    setLoading(true);
    const stepValues = Object.values(fields)
      .map((field) => field.key)
      .reduce((acc, item) => {
        acc[item] = values[item] || null;
        return acc;
      }, {});

    const draftChangeStrategy = {
      image: selectedImage || null,
      ...stepValues,
    };

    if (finish) {
      updateChangeStrategy(
        projectId,
        { change_strategy: draftChangeStrategy },
        true,
        true
      )
        .then(() => goStart())
        .catch(mapErrors);
    } else {
      updateChangeStrategyDraft(
        projectId,
        { change_strategy: draftChangeStrategy },
        true,
        true,
        !changeStrategyDraft
      )
        .then(() => {
          setIsDraftToDelete(false);
          goNext();
        })
        .catch(mapErrors);
    }
  };

  const validate = (values) =>
    generalStrategyStepValidate(selectedImage, imageSize, values);

  useEffect(() => {
    retrieveProject(projectId).then((result) => {
      if (result.entities.projects[projectId].changeStrategyExists) {
        retrieveChangeStrategy(projectId);
      }
    });
  }, []);

  return (
    <React.Fragment>
      <MultistepCombinedHeader
        editing={editing}
        subject="Change Strategy"
        typeStep="General"
      >
        {project && (
          <ChangeStrategyFormHeader
            slug={slug}
            project={project}
            editing={editing}
          />
        )}
      </MultistepCombinedHeader>
      <Grid>
        <Row>
          <Col sm={12}>
            <div className="component-xl component-bg-white component-xl-padding-vertical component-no-horizontal-padding">
              {project ? (
                <Row>
                  <Col sm={10} smOffset={1}>
                    <Form
                      onSubmit={onSubmit}
                      initialValues={
                        initialValues || { project_impact: project.impact }
                      }
                      validate={validate}
                      onCancel={onCancel}
                      fields={fields}
                      loading={loading}
                      handleImageSelect={handleImageSelect}
                      clearImageField={clearImageField}
                      onShowAddStakeholderModal={() => setShowFormModal(true)}
                      changeStrategyDraft={changeStrategyDraft}
                      component={StepGeneralForm}
                    />
                  </Col>
                </Row>
              ) : null}
            </div>
          </Col>
        </Row>
      </Grid>
    </React.Fragment>
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StepGeneralFormContainer);
